import {
	Box,
	Checkbox,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { CheckIcon, UncheckIcon } from "assests/images";
import React, { useState } from "react";
import { SortOrder } from "utility/enums/sort-order";
import {
	IProviderDropdownList,
	IProviderInfoSearchCriteria,
	IShift,
	IShiftsInfo,
} from "utility/interfaces";
import { visuallyHidden } from "@mui/utils";
import { CurrentMonthShiftsTableRow } from "./current-month-shifts-table-row";
import { ViewAllShiftsModal } from "./view-all-shifts-modal";

type ComponentProps = {
	searchCriteria: IProviderInfoSearchCriteria;
	shiftsInfo: IShiftsInfo;
	handleChangeSearchCriteria: any;
	selectedShifts: number[];
	setSelectedShifts: any;
	selectAll: boolean;
	setSelectAll: any;
	physicianList: IProviderDropdownList[];
};

export const CurrentMonthShiftsTable = (props: ComponentProps) => {
	// Extract Props
	const {
		searchCriteria,
		shiftsInfo,
		handleChangeSearchCriteria,
		selectAll,
		setSelectAll,
		selectedShifts,
		setSelectedShifts,
		physicianList,
	} = props;

	// Use state
	const [viewAllData, setViewAllData] = useState<IShift[]>([]);
	const [isViewAllShiftModalOpen, setIsViewAllShiftsModalOpen] =
		useState(false);

	// Handle events
	const handleOnChangeSortDirection = (sortBy: string) => {
		handleChangeSearchCriteria({
			...searchCriteria,
			SortBy: sortBy,
			SortOrder:
				searchCriteria.SortOrder === SortOrder.ascending
					? SortOrder.descending
					: SortOrder.ascending,
		});
	};

	const handleViewShiftsModalOpen = () => {
		setIsViewAllShiftsModalOpen(true);
	};

	const handleViewShiftsModalClose = () => {
		setIsViewAllShiftsModalOpen(false);
	};

	const CheckedboxIcon = () => {
		return <img src={CheckIcon} alt="checkbox" />;
	};
	const CheckboxIcon = () => {
		return <img src={UncheckIcon} alt="checkbox" />;
	};

	const handleSelectShift = (physicianId: number) => {
		if (selectedShifts.includes(physicianId)) {
			let changedSelected = selectedShifts.filter((s) => s !== physicianId);
			setSelectedShifts(changedSelected);
			if (changedSelected.length !== physicianList.length) setSelectAll(false);
		} else {
			let changedSelected = [...selectedShifts, physicianId];
			if (changedSelected.length === physicianList.length) {
				setSelectAll(true);
			}
			setSelectedShifts(changedSelected);
		}
	};

	const handleSelectAll = () => {
		if (selectAll) {
			setSelectedShifts([]);
			setSelectAll(false);
		} else {
			let allShifts = physicianList.map((s) => {
				return s.physicianId;
			});
			setSelectedShifts(allShifts);
			setSelectAll(true);
		}
	};

	const handleViewAllBtnClick = (physicianId: number) => {
		console.log(physicianId);
		let selectedPhysiciandata = shiftsInfo.shifts.filter(
			(shift) => shift.physicianId == physicianId
		);
		console.log(selectedPhysiciandata);
		setViewAllData(selectedPhysiciandata);
		handleViewShiftsModalOpen();
	};

	return (
		<>
			<TableContainer
				className="upload-table-container"
				sx={{ display: { xs: "none", laptop: "block" } }}
			>
				<Table className="upload-table checkbox-table">
					<TableHead>
						<TableRow>
							<TableCell className="min-w-100" align="center">
								<Checkbox
									onClick={handleSelectAll}
									icon={<CheckboxIcon />}
									checkedIcon={<CheckedboxIcon />}
									checked={selectAll}
									disableRipple
									disableFocusRipple
									inputProps={{
										"aria-labelledby": `enhanced-table-checkbox--1`,
									}}
								/>
							</TableCell>
							<TableCell
								sortDirection={searchCriteria.SortOrder}
								className="min-w-200"
							>
								<TableSortLabel
									active={searchCriteria.SortBy === "PhysicianName"}
									direction={searchCriteria.SortOrder}
									onClick={() => handleOnChangeSortDirection("PhysicianName")}
								>
									Staff
									<Box component="span" sx={visuallyHidden}>
										{searchCriteria.SortOrder === SortOrder.descending
											? "sorted descending"
											: "sorted ascending"}
									</Box>
								</TableSortLabel>
							</TableCell>
							<TableCell
								sortDirection={searchCriteria.SortOrder}
								className="min-w-160"
							>
								<TableSortLabel
									active={searchCriteria.SortBy === "Day"}
									direction={searchCriteria.SortOrder}
									onClick={() => handleOnChangeSortDirection("Day")}
								>
									Day
									<Box component="span" sx={visuallyHidden}>
										{searchCriteria.SortOrder === SortOrder.descending
											? "sorted descending"
											: "sorted ascending"}
									</Box>
								</TableSortLabel>
							</TableCell>
							<TableCell
								sortDirection={searchCriteria.SortOrder}
								className="min-w-160"
							>
								<TableSortLabel
									active={searchCriteria.SortBy === "Time"}
									direction={searchCriteria.SortOrder}
									onClick={() => handleOnChangeSortDirection("Time")}
								>
									Approve
									<Box component="span" sx={visuallyHidden}>
										{searchCriteria.SortOrder === SortOrder.descending
											? "sorted descending"
											: "sorted ascending"}
									</Box>
								</TableSortLabel>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{physicianList.map((row, index) => {
							return (
								<TableRow hover tabIndex={-1} key={index}>
									<CurrentMonthShiftsTableRow
										index={index}
										row={row}
										handleOnSelectRow={handleSelectShift}
										selected={selectedShifts.includes(row.physicianId)}
										handleViewAllBtnClick={handleViewAllBtnClick}
										isSmallDevice={false}
									/>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			<Box
				sx={{ display: { xs: "block", laptop: "none" } }}
				className="tabledata-cards-group"
			>
				{physicianList.map((row, index) => {
					return (
						<CurrentMonthShiftsTableRow
							key={index}
							index={index}
							row={row}
							handleOnSelectRow={handleSelectShift}
							selected={selectedShifts.includes(row.physicianId)}
							handleViewAllBtnClick={handleViewAllBtnClick}
							isSmallDevice={true}
						/>
					);
				})}
			</Box>

			{/* Page modal */}
			<ViewAllShiftsModal
				shifts={viewAllData}
				handleClose={handleViewShiftsModalClose}
				isOpen={isViewAllShiftModalOpen}
				isRequestedShiftPage={true}
				date=""
				handleShiftClick={() => {}}
			/>
		</>
	);
};
